function regexCheck(string, regex) {
  return regex.test(String(string).toLowerCase());
}
export default regexCheck;
